import CodeUtil from '../../../util/CodeUtil';
import {
    CODE_GROUP_ID,
    SUBJECT_SEARCH_BODY_PATH,
    COMMUNITY_NOTICE_DETAIL_PATH,
    PATH_DELIMITER,
} from '../../../constant/Constant';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import ConfigUtil from '../../../util/ConfigUtil';
import SelectionBox from '../../../component/SelectionBox';
import InputBox from '../../../component/InputBox';
import CautionBox from '../../../component/CautionBox';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import PathUtil from '../../../util/PathUtil';
import CarouselBox from '../../../component/CarouselBox';
import { useDispatch, useSelector } from 'react-redux';
import { actionSearch } from '../../../module/body/community/notice/CommunityNoticeModule';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { initGrid } from '../../../module/component/TableBoxModule';
import { handleSemesterNm } from '../../../module/body/subject/SubjectSearchModule';
import SemesterUtil from '../../../util/SemesterUtil';

const MainView = () => {
    const webType = ConfigUtil.getWebType().toLowerCase();

    // 화면이동을 위한 함수선언
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [semesterId, setSemesterId] = useState(SessionStorageUtil.getCurrentSemesterId());
    const [subjectTypeCd, setSubjectTypeCd] = useState();
    const [lessonUniversityCd, setLessonUniversityCd] = useState();
    const [lessonTypeCd, setLessonTypeCd] = useState();
    const [subjectNm, setSubjectNm] = useState();
    const [communityNoticeArr, setCommunityNoticeArr] = useState([]);

    const { semesterNm } = useSelector((state) => state.subjectSearchState);

    useEffect(() => {
        communityNoticeSearch();
        dispatch(handleSemesterNm(SemesterUtil.convertSemesterNm(semesterId)));

        return () => {
            dispatch(initGrid());
        };
    }, []);

    const communityNoticeSearch = (e) => {
        dispatch(
            actionSearch({
                params: {
                    noticeTypeCd: '',
                    postingTitleNm: '',
                    page: 0,
                    pageSize: 10,
                },
                callback: (result) => {
                    let idx = 0;
                    let count = 0;
                    let noticeArr = [];
                    if (NullCheckUtil.isNotEmpty(result)) {
                        while (count < 5 && idx < result.rows.length) {
                            let el = {};
                            el.postingNo = result.rows[idx].postingNo;
                            el.postingTitleNm = result.rows[idx].postingTitleNm;
                            el.topDisplay = result.rows[idx].topDisplay;
                            if (result.rows[idx].regDttm && result.rows[idx].regDttm.length > 10) {
                                el.regDttm = result.rows[idx].regDttm.substring(0, 10);
                            }
                            noticeArr.push(el);
                            count++;
                            idx++;
                        }
                    }
                    setCommunityNoticeArr(noticeArr);
                },
            }),
        );
    };

    const handleSearch = (e) => {
        // 화면이동 함수 호출 (경로값은 Constant 참조)
        const path = PathUtil.pushState(SUBJECT_SEARCH_BODY_PATH, {
            semesterId,
            subjectTypeCd,
            lessonUniversityCd,
            lessonTypeCd,
            subjectNm,
        });
        navigate(path);
    };

    const onClickCommunityNotice = (e, postingNo) => {
        if (postingNo) {
            var path = COMMUNITY_NOTICE_DETAIL_PATH + PATH_DELIMITER + postingNo;
            navigate(path);
        }
    };

    const communityNoticeList = communityNoticeArr.map((el) => (
        <li
            className='notice-items'
            key={el.postingNo}
            onClick={(e, postingNo) => onClickCommunityNotice(e, el.postingNo)}
        >
            <a href='#none' className='notice-items-inner'>
                <span className={el.topDisplay ? 'notice-icon answer-mark blue' : 'notice-icon answer-mark gray'}>
                    {el.topDisplay ? '중요' : '일반'}
                </span>
                <span className='notice-tit'>{el.postingTitleNm}</span>
                <span className='notice-date'>{el.regDttm}</span>
            </a>
        </li>
    ));

    const openSearchPopup = (e) => {
        // useState로 생성한 변수설정
        setOpen(true);
    };

    return (
        <section className='container'>
            <div className='main-wrap'>
                {/* <div className={`main-con01 ${webType}`}> */}
                <div className='main-con01'>
                    <div className='main-inner'>
                        <div className='main-info-box'>
                            <p className='info-txt'>
                                미래 자동차 산업의 핵심
                                <br />
                                첨단분야 혁신융합대학사업(미래자동차)
                            </p>
                        </div>
                    </div>
                </div>
                <div className='main-con02'>
                    <div className='main-inner'>
                        <div className='board-title'>
                            <h2>강의조회</h2>
                        </div>
                        <div className='board-content'>
                            <div className='lec-check-box'>
                                <div className='form-box-container'>
                                    <SelectionBox
                                        title='학기'
                                        value={semesterId}
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                        onChange={(e) => setSemesterId(e.target.value)}
                                        useAll={false}
                                    />
                                    <SelectionBox
                                        title='마이크로디그리 과정'
                                        value={subjectTypeCd}
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.SUBJECT_TYPE)}
                                        onChange={(e) => setSubjectTypeCd(e.target.value)}
                                    />
                                    <InputBox
                                        title='교과목'
                                        value={subjectNm}
                                        onChange={(e) => setSubjectNm(e.target.value)}
                                    />
                                    <SelectionBox
                                        title='개설대학'
                                        w140
                                        value={lessonUniversityCd}
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                        onChange={(e) => setLessonUniversityCd(e.target.value)}
                                    />
                                    <SelectionBox
                                        title='수업방식'
                                        w140
                                        value={lessonTypeCd}
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.LESSON_TYPE)}
                                        onChange={(e) => setLessonTypeCd(e.target.value)}
                                    />
                                </div>
                                <div className='lec-check-btn'>
                                    <SearchButtonBox title='강의조회' onClick={handleSearch} />
                                </div>
                            </div>
                            <CautionBox
                                title='수강신청 유의사항 확인'
                                checkedEnabled={false}
                                path='#none;'
                                semesterId={semesterId}
                                semesterNm={semesterNm}
                            />
                        </div>
                    </div>
                </div>
                <div className='main-con03'>
                    <div className='main-inner'>
                        <div className='board-title'>
                            <h2>공지사항</h2>
                        </div>
                        <div className='board-content'>
                            <div className='notice-wrap'>
                                <ul className='notice-list'>
                                    {communityNoticeList}
                                    {/* <li className='notice-items'>
                                        <a href='#none' className='notice-items-inner'>
                                            <span className='notice-tit'>
                                                2022년 졸업예정자
                                                <br />
                                                신청안내
                                            </span>
                                            <span className='notice-date'>22.04.20</span>
                                        </a>
                                    </li>
                                    <li className='notice-items'>
                                        <a href='#none' className='notice-items-inner'>
                                            <span className='notice-tit'>
                                                2022년 졸업예정자
                                                <br />
                                                신청안내
                                            </span>
                                            <span className='notice-date'>22.04.20</span>
                                        </a>
                                    </li>
                                    <li className='notice-items'>
                                        <a href='#none' className='notice-items-inner'>
                                            <span className='notice-tit'>
                                                2022년 졸업예정자
                                                <br />
                                                신청안내
                                            </span>
                                            <span className='notice-date'>22.04.20</span>
                                        </a>
                                    </li>
                                    <li className='notice-items'>
                                        <a href='#none' className='notice-items-inner'>
                                            <span className='notice-tit'>
                                                2022년 졸업예정자
                                                <br />
                                                신청안내
                                            </span>
                                            <span className='notice-date'>22.04.20</span>
                                        </a>
                                    </li>
                                    <li className='notice-items'>
                                        <a href='#none' className='notice-items-inner'>
                                            <span className='notice-tit'>
                                                2022년 졸업예정자
                                                <br />
                                                신청안내
                                            </span>
                                            <span className='notice-date'>22.04.20</span>
                                        </a>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='main-con04'>
                    <div className='main-inner'>
                        <CarouselBox />
                        {/* <div className='list-swipe-wrap'>
                            <div className='list-swipe-inner'>
                                <ul className='college-list'>
                                    <li className='univ-logo kmu'>
                                        <a href='#none;'></a>
                                    </li>
                                    <li className='univ-logo kookmin'>
                                        <a href='#none;'></a>
                                    </li>
                                    <li className='univ-logo daelim'>
                                        <a href='#none;'></a>
                                    </li>
                                    <li className='univ-logo sunmoon'>
                                        <a href='#none;'></a>
                                    </li>
                                    <li className='univ-logo ajou'>
                                        <a href='#none;'></a>
                                    </li>
                                    <li className='univ-logo inha'>
                                        <a href='#none;'></a>
                                    </li>
                                    <li className='univ-logo chungbuk'>
                                        <a href='#none;'></a>
                                    </li>
                                </ul>
                            </div>
                            <button type='button' className='btn swipe-btn prev'></button>
                            <button type='button' className='btn swipe-btn next'></button>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MainView;
